import React, { useState, useEffect } from 'react';
import ComboBox from 'Components/ComboBox/ComboBox';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import Panel from 'Components/Panel/Panel';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';

function AnalyticsFilter({
    onUpdateSectorSelected,
    onUpdateManagerSelected,
    onUpdateEmployeeSelected,
    updateSectorsEmployees,
    onUpdateSelectedActualDate,
    selectedActualDate,
    sectorSelected,
    managerSelected,
    employeeSelected,
    sectorEmployees }) {
    const [sectors, setSectors] = useState([]);
    const [managers, setManagers] = useState([]);

    const cleanManager = () => {
        setManagers([])
        onUpdateManagerSelected("")
    }

    const cleanEmployee = () => {
        updateSectorsEmployees([]);
        onUpdateEmployeeSelected("")
    }

    useEffect(() => {
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (sectorSelected) {
            const fetchManagers = async () => {

                cleanManager()
                cleanEmployee()

                const parameters = { sectorId: parseInt(sectorSelected) }
                const managers = await ExecuteAxios.api('get', `/manager/lookup/`, { params: parameters });
                setManagers(managers);
            };

            fetchManagers();
        } else {
            cleanManager()
            cleanEmployee()
        }
    }, [sectorSelected]);

    useEffect(() => {
        if (sectorSelected) {
            updateSectorsEmployees([]);
            const fetchEmployees = async () => {
                const parameters = {
                    sectorId: sectorSelected,
                    managerId: managerSelected
                };
                updateSectorsEmployees(await ExecuteAxios.api('get', '/client/lookup', { params: parameters }));
            };
            fetchEmployees();
        }
    }, [sectorSelected, managerSelected]);

    const sectorOptions = OptionsDataByAttributePath(sectors, ['sectorName'], null, true)
    const managerOptions = OptionsDataByAttributePath(managers, ['name'], null, true)
    const employeeOptions = OptionsDataByAttributePath(sectorEmployees, ['user', 'name'], null, true)

    const mainPanelStyle = {
        minWidth: '20%',
        maxWidth: '20%',
        flexDirection: 'column',
        display: 'flex',
        borderRight: '2px solid #ccc',
        padding: '1% 1%'
    };

    const styleCombox = {
        marginBottom: '20px',
        flexDirection: 'column',
        display: 'flex',
        flexGrow: '1'
    }

    return (
        <Panel style={mainPanelStyle}>
            <LoadingIndicator loaded={true}>
                <Panel style={{ display: 'flex', flexDirection: 'column', minWidth: '100%', maxWidth: '100%' }}>
                    <h3 style={{ marginTop: '2%' }}> Filtros</h3>
                    <Panel style={styleCombox}>
                        <span>Setor</span>
                        <ComboBox setAttribute={onUpdateSectorSelected}
                            optionsData={sectorOptions}
                            style={{ marginBottom: '25px' }}
                            value={sectorSelected}
                            defaultValue={sectorSelected}
                        />

                        <span>Gerente</span>
                        <ComboBox setAttribute={onUpdateManagerSelected}
                            optionsData={managerOptions}
                            style={{ marginBottom: '25px' }}
                            value={managerSelected}
                            defaultValue={managerSelected}
                        />

                        <span>Colaborador</span>
                        <ComboBox setAttribute={onUpdateEmployeeSelected}
                            optionsData={employeeOptions}
                            style={{ marginBottom: '25px' }}
                            value={employeeSelected}
                            defaultValue={employeeSelected}
                        />

                        <span>Mês/Ano</span>
                        <ReactDataPickerComp
                            selected={selectedActualDate}
                            onChange={(date) => { onUpdateSelectedActualDate(date) }}
                            wrapperClassName={'width-full'}
                            className='validate-attribute width-full cursor-pointer'
                            showMonthYearPicker={true}
                            dateFormat={'MM/yyyy'}
                            setter={onUpdateSelectedActualDate}
                        />
                    </Panel>
                </Panel>
            </LoadingIndicator >
        </Panel >
    );
}

export default AnalyticsFilter;